<script>
    export let iconClass = "size-6";
    export let textClass = "text-sm";
    export let showText = true;
</script>

<span class="inline-flex items-center gap-2">
    <img src="/uwubox-logo.png" alt="" class="object-contain {iconClass}" aria-hidden="true" />
    {#if showText}
        <span class="font-bold tracking-[-0.03em] text-foreground {textClass}">uwubox</span>
    {/if}
</span>
